// extracted by mini-css-extract-plugin
var _1 = "UserItem_menuItem__lin5F";
var _2 = "UserItem_menuItemText__5jLX0";
export { _1 as "menuItem", _2 as "menuItemText" }
